import MatchComments from './MatchComments'

export default MatchComments
